import React, {useState, useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import "../index.css"

import _ from "lodash";
import { Dialog } from "primereact/dialog";

import { DropDownField } from "../../../helpers";

import POPunch from "../../BuyerPO/Components/POPunch";

import { setSelectedBuyerPO } from "../../../services/redux/reducers/Requirement/requirement";

import { getDateString } from "../../../utils";


const POPunchModal = (props) => {
    const { buyerPOs, selectedReq,  visiblePOPunch, setVisiblePOPunch } = props

    const [relatedBuyerPO, setRelatedBuyerPO] = useState([])

    const selectedBuyerPOId = useSelector(state => state.requirements.selectedBuyerPO)

    const dispatch = useDispatch()

    useEffect(()=>{
        return () => {
            dispatch(setSelectedBuyerPO(null))
        }
    }, [])

    useEffect(() => {
        if (buyerPOs && selectedReq){
            let relatedBuyerPOs = buyerPOs?.filter(eachBuyerPO => eachBuyerPO.buyerReqId === selectedReq.buyerReqId)
            relatedBuyerPOs  = relatedBuyerPOs?.map(eachBuyerPO => {
                let createdAtString = getDateString(eachBuyerPO?.createdAt)
                return {...eachBuyerPO, docNo: `${eachBuyerPO?.docNo} (${createdAtString})`}
            })
            relatedBuyerPOs = relatedBuyerPOs?.filter(eachBuyerPO => [3, 4].includes(eachBuyerPO?.statusId))
            relatedBuyerPOs = _.sortBy(relatedBuyerPOs, "createdAt")

            if (relatedBuyerPOs?.length > 1){
                setRelatedBuyerPO(relatedBuyerPOs)
            }else{
                setRelatedBuyerPO(relatedBuyerPOs)
                dispatch(setSelectedBuyerPO(relatedBuyerPOs?.[0]?.buyerPOId))
            }
        }
    },[buyerPOs, selectedReq])

    const handleOnHideDialog = () => {
        setVisiblePOPunch(false)
        setRelatedBuyerPO([])
        dispatch(setSelectedBuyerPO(null))
    }

    const renderHeader = () => {
        return(
            <div className="flex flex-row justify-content-between">
                <p>PO PUNCH</p>
                {
                    relatedBuyerPO.length ?
                    <div className="col-5 flex flex-row justify-content-end align-items-center py-0">
                        <span style={{fontSize:"13px", marginRight: "5px"}} >Buyer PO No: </span>
                        <span className=""><DropDownField name="selected" options={relatedBuyerPO} optionLabel="docNo" optionValue="buyerPOId" value={selectedBuyerPOId} className="document-select-dropdown" onChange={(e) => {dispatch(setSelectedBuyerPO(e.target.value))}}/></span>
                    </div> 
                    :
                    null
                }
            </div>
        )
    }

    return (
        <Dialog header={renderHeader} className="po-punch-dialog" visible={visiblePOPunch} style={{ width: '90vw', height: '85vh', backgroundColor: '#f8f8f8' }} onHide={() => handleOnHideDialog()} >
            <POPunch buyerPOId={selectedBuyerPOId} selectedReq={selectedReq} />
        </Dialog>
    )
}

export default POPunchModal;